export default __webpack_public_path__ + "static/media/14.078f27df.jpg";